/** 将研修营接口返回的日期、时间戳或 [年, 月, 日] 数组统一格式化为 yyyy-MM-dd。 */
export function formatCampDate (value) {
  if (value === null || value === undefined || value === '') return ''

  if (Array.isArray(value)) {
    if (value.length < 3) return ''
    const year = Number(value[0])
    const month = Number(value[1])
    const day = Number(value[2])
    if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) return ''
    return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
  }

  const raw = String(value).trim()
  if (!raw) return ''
  if (/^(19|20)\d{6}$/.test(raw)) {
    return `${raw.slice(0, 4)}-${raw.slice(4, 6)}-${raw.slice(6, 8)}`
  }

  const chineseDate = raw.match(/^(\d{4})年(\d{1,2})月(\d{1,2})日/)
  if (chineseDate) {
    const month = String(chineseDate[2]).padStart(2, '0')
    const day = String(chineseDate[3]).padStart(2, '0')
    return `${chineseDate[1]}-${month}-${day}`
  }

  if (!/^\d+$/.test(raw)) return raw.slice(0, 10)

  const timestamp = Number(raw)
  const date = new Date(raw.length <= 10 ? timestamp * 1000 : timestamp)
  if (Number.isNaN(date.getTime())) return ''

  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${date.getFullYear()}-${month}-${day}`
}

/** 将研修营接口返回的日期时间统一格式化为 yyyy-MM-dd HH:mm。 */
export function formatCampDateTime (value) {
  if (value === null || value === undefined || value === '') return ''

  if (Array.isArray(value) && value.length >= 3) {
    const [year, month, day, hour = 0, minute = 0] = value
    return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')} ${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`
  }

  const raw = String(value).trim()
  if (!raw) return ''
  if (/^\d{8}$/.test(raw)) {
    return `${raw.slice(0, 4)}-${raw.slice(4, 6)}-${raw.slice(6, 8)}`
  }
  if (/^\d{12}$/.test(raw) || /^\d{14}$/.test(raw)) {
    return `${raw.slice(0, 4)}-${raw.slice(4, 6)}-${raw.slice(6, 8)} ${raw.slice(8, 10)}:${raw.slice(10, 12)}`
  }
  if (/^\d+$/.test(raw)) {
    const timestamp = Number(raw)
    const date = new Date(timestamp < 100000000000 ? timestamp * 1000 : timestamp)
    if (Number.isNaN(date.getTime())) return ''
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const hour = String(date.getHours()).padStart(2, '0')
    const minute = String(date.getMinutes()).padStart(2, '0')
    return `${date.getFullYear()}-${month}-${day} ${hour}:${minute}`
  }

  const dateTime = raw.match(/^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2})/)
  if (dateTime) return `${dateTime[1]} ${dateTime[2]}`
  return raw.slice(0, 16)
}



// WEBPACK FOOTER //
// ./src/views/researchCamp/date.js